import { schema } from "normalizr";
import { organizationSchema } from "../organization";

export const locationSchema = new schema.Entity("locations", {
  organization: organizationSchema
});
